import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {Language} from "./api.models";
import {Observer} from "rxjs/Observer";

export class LanguagesEndpoint extends Request {
    protected cache: Language[];
    protected cacheToken: string;

    collection(): Observable<Language[]> {
        return Observable.create((observer: Observer<any>) => {
            if (this.cache && this.cacheToken === this.settings.token) {
                observer.next(this.cache);
                observer.complete();

                return;
            }

            this.get('/v1/languages').subscribe(
                (languages: Language[]) => {
                    this.cache      = [];
                    this.cacheToken = this.settings.token;
                    languages.forEach((language: Language) => {
                        this.cache.push(Object.assign(language));
                    });

                    observer.next(languages);
                },
                (error: any) => {
                    observer.error(error);
                },
                () => {
                    observer.complete();
                }
            );
        });
    }

    add(language: Language): Observable<Language> {
        this.cache = null;

        return this.post('/v1/languages', language);
    }

    remove(id: number): Observable<Boolean> {
        this.cache = null;

        return this.delete('/v1/languages/' + id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/languages/api.service.ts